import { render, staticRenderFns } from "./newMessage.vue?vue&type=template&id=761f6000&"
import script from "./newMessage.vue?vue&type=script&lang=js&"
export * from "./newMessage.vue?vue&type=script&lang=js&"
import style0 from "./newMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports